import React, { useState, useEffect } from 'react'; 
import { Button } from '@material-ui/core';
import MyButton from '../../../utils/MyButton';
import { FaArrowCircleLeft, FaExclamationTriangle, FaFileExcel, FaFilePdf } from "react-icons/fa";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getCliente } from '../../../redux/actions/dataactions';
import { PDFViewer } from '@react-pdf/renderer';
import './CronogramaMtoPDF.css';
import CronogramaMtoDocuPDF from './CronogramaMtoDocuPDF';
import { useHistory, Link } from 'react-router-dom';
import * as XLSX from 'xlsx';

const ErrorDisplay = ({ message, onReturn }) => (
  <div style={{ 
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center',
    backgroundColor: '#f8f9fa'
  }}>
    <div style={{
      backgroundColor: 'white',
      padding: '2rem',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      maxWidth: '400px',
      width: '100%',
      textAlign: 'center'
    }}>
      <FaExclamationTriangle 
        size={40} 
        style={{ 
          color: '#f44336',
          marginBottom: '1rem'
        }}
      />
      <h3 style={{
        color: '#333',
        marginBottom: '1rem',
        fontSize: '1.2rem'
      }}>
        Atención
      </h3>
      <p style={{
        color: '#666',
        marginBottom: '1.5rem',
        lineHeight: '1.5'
      }}>
        {message}
      </p>
      <Button 
        variant="contained" 
        color="primary" 
        onClick={onReturn}
        style={{ 
          textTransform: 'none',
          padding: '8px 24px'
        }}
      >
        Volver a la página anterior
      </Button>
    </div>
  </div>
);

function CronogramaMtoPDF(props) {
  const [verPDF, setVerPDF] = useState(false);
  const [hasData, setHasData] = useState(false);
  const history = useHistory();
  const { equiposmto, cliente } = props.data;

  useEffect(() => {
    props.getCliente(props.match.params.clienteId);
  }, [props.match.params.clienteId]);

  useEffect(() => {
    const hasEquipos = equiposmto && equiposmto.length > 0;
    setHasData(hasEquipos);
  }, [equiposmto]);

  const handleReturn = () => {
    history.push(`/dashboard/perfilcliente/${props.match.params.clienteId}/cronomtoperfil`);
  };

  // ---------- EXPORTAR A EXCEL (basado en InventarioPDF) ----------
  const exportToExcel = () => {
    if (!equiposmto || equiposmto.length === 0) {
      alert('No hay datos del cronograma para exportar');
      return;
    }

    // Crear libro
    const workbook = XLSX.utils.book_new();

    // Encabezado del reporte
    const headerData = [
      ['CRONOGRAMA DE MANTENIMIENTOS PREVENTIVOS', '', '', '', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', '', '', '', ''],
      [
        'Cliente:', cliente?.nombre || 'No disponible', '', '',
        'CC/NIT:', cliente?.ccnit || 'No disponible', '', '',
        'Ciudad:', cliente?.ciudad || 'No disponible', ''
      ],
      ['Fecha:', new Date().toLocaleDateString('es-CO'), '', '', '', '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', '', '', '', '']
    ];

    // Encabezados de tabla según lo que pediste
    const tableHeaders = [[
      'ID Inventario',
      'ID Mto Prev (últimos 6)',
      'Nombre',
      'Marca',
      'Modelo',
      'Serie',
      'Ubicación',
      'Fecha',
      'Mes',
      'Estado',
      'Actividades'
    ]];

    // Ordenar por ubicación (opcional, igual que en inventario)
    const datosOrdenados = [...equiposmto].sort((a, b) => {
      const ubicA = (a.ubicacion || 'Sin ubicación').toLowerCase();
      const ubicB = (b.ubicacion || 'Sin ubicación').toLowerCase();
      return ubicA.localeCompare(ubicB);
    });

    const tableData = datosOrdenados.map(item => {
      // actividades puede ser string o arreglo
      let actividades = '';
      if (Array.isArray(item.actividades)) {
        actividades = item.actividades.join(', ');
      } else if (item.actividades) {
        actividades = item.actividades;
      }

      // fecha formateada
      let fechaStr = '';
      if (item.fecha) {
        try {
          // Si viene como timestamp o fecha válida
          const fechaObj = new Date(item.fecha);
          if (!isNaN(fechaObj.getTime())) {
            fechaStr = fechaObj.toLocaleDateString('es-CO');
          } else {
            // Si ya viene como string tipo "DD/MM/YYYY"
            fechaStr = item.fecha;
          }
        } catch (e) {
          fechaStr = item.fecha;
        }
      }

      // mes: intentamos usar mesnombre si existe, si no, mes
      const mesStr = item.mesnombre || item.mes || '';

      return [
        item.idinventario || '',
        item.mtoprevid || 'no registra',
        item.nombre || '',
        item.marca || '',
        item.modelo || '',
        item.serie || '',
        item.ubicacion || '',
        fechaStr,
        mesStr,
        item.estado || '',
        actividades
      ];
    });

    const footerData = [
      ['', '', '', '', '', '', '', '', '', '', ''],
      ['Generado por Alpha Biomédica - www.alphabiomedica.com', '', '', '', '', '', '', '', '', '', '']
    ];

    // Combinar todos los datos
    const sheetData = [...headerData, ...tableHeaders, ...tableData, ...footerData];

    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

    // Ancho de columnas
    worksheet['!cols'] = [
      { wch: 12 }, // ID Inventario
      { wch: 18 }, // ID Mto Prev
      { wch: 25 }, // Nombre
      { wch: 15 }, // Marca
      { wch: 15 }, // Modelo
      { wch: 15 }, // Serie
      { wch: 20 }, // Ubicacion
      { wch: 12 }, // Fecha
      { wch: 10 }, // Mes
      { wch: 12 }, // Estado
      { wch: 40 }  // Actividades
    ];

    // Fusiones (título, datos cliente, footer)
    worksheet['!merges'] = [
      // Título
      { s: { r: 0, c: 0 }, e: { r: 0, c: 10 } },
      // Cliente
      { s: { r: 2, c: 1 }, e: { r: 2, c: 2 } },
      { s: { r: 2, c: 5 }, e: { r: 2, c: 6 } },
      { s: { r: 2, c: 9 }, e: { r: 2, c: 10 } },
      // Footer
      {
        s: { r: tableData.length + headerData.length + tableHeaders.length + 1, c: 0 },
        e: { r: tableData.length + headerData.length + tableHeaders.length + 1, c: 10 }
      }
    ];

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Cronograma Mtos');

    const fechaActual = new Date().toISOString().slice(0, 10);
    const fileName = `Cronograma_Mantenimientos_${cliente?.nombre || 'Cliente'}_${fechaActual}.xlsx`;

    XLSX.writeFile(workbook, fileName);
  };
  // ----------------------------------------------------------------

  if (!hasData) {
    return (
      <ErrorDisplay 
        message="No hay equipos para mostrar. Por favor, vuelva a ejecutar la consulta."
        onReturn={handleReturn}
      />
    );
  }

  if (!cliente?.plantillaType) {
    return (
      <ErrorDisplay 
        message="Para ver las plantillas, primero debe configurar el tipo de plantilla en la lista de clientes"
        onReturn={handleReturn}
      />
    );
  }

  return (
    <div className='mto_pdf_container'>
      <div className='mto_pdf_header'>
        <div className="mto_pdf_toolbar">
          <div className="mto_pdf_left_section">
            <Link to={`/dashboard/perfilcliente/${props.match.params.clienteId}/cronomtoperfil`}>
              <MyButton tip="Volver">
                <FaArrowCircleLeft color="#03178C" className="mto_pdf_back_icon"/>
              </MyButton>
            </Link>
          </div>
          <div className="mto_pdf_right_section">
            {/* Botón PDF */}
            <Button
              variant="outlined"
              color="primary"
              onClick={() => setVerPDF(!verPDF)}
              className="mto_pdf_view_btn"
              style={{ marginRight: '10px' }}
              startIcon={<FaFilePdf />}
            >
              {verPDF ? 'Ocultar PDF' : 'Ver PDF'}
            </Button>

            {/* Botón Excel */}
            <Button
              variant="outlined"
              color="primary"
              onClick={exportToExcel}
              className="mto_pdf_excel_btn"
              startIcon={<FaFileExcel />}
            >
              Exportar a Excel
            </Button>
          </div>
        </div>
      </div>

      <div className='mto_pdf_content'>
        {verPDF && (
          <PDFViewer style={{ width: "100%", height: "90vh" }}>
            <CronogramaMtoDocuPDF equipos={equiposmto} cliente={cliente} />
          </PDFViewer>
        )}
      </div>
    </div>
  );
}

CronogramaMtoPDF.propTypes = {
  getCliente: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  data: state.data,
});

export default connect(mapStateToProps, { getCliente })(CronogramaMtoPDF);
